import { useAuthStore } from "../store/authStore";

export default function DashboardPage() {
  const { user } = useAuthStore();

  return (
    <div>
      <h1 className="text-3xl font-bold text-gray-100 mb-2">
        Welcome back, {user?.email}
      </h1>
      <p className="text-gray-400 mb-8">
        Logged in as <span className="text-primary-500 capitalize">{user?.role?.replace("_", " ")}</span>
      </p>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <div className="card">
          <h3 className="text-lg font-semibold text-gray-300 mb-2">Your Role</h3>
          <p className="text-2xl font-bold text-primary-500 capitalize">
            {user?.role?.replace("_", " ")}
          </p>
        </div>

        <div className="card">
          <h3 className="text-lg font-semibold text-gray-300 mb-2">Status</h3>
          <p className="text-2xl font-bold capitalize text-green-500">{user?.status || "Active"}</p>
        </div>

        <div className="card">
          <h3 className="text-lg font-semibold text-gray-300 mb-2">Email Verified</h3>
          <p className="text-2xl font-bold">{user?.email_verified ? "✓ Yes" : "✗ No"}</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="card">
          <h2 className="text-xl font-bold text-gray-100 mb-4">Quick Actions</h2>
          <div className="space-y-3">
            <a
              href="/surveys"
              className="block btn btn-primary text-center"
            >
              Browse Surveys
            </a>
            {user?.role === "question_owner" && (
              <a href="/surveys/create" className="block btn btn-secondary text-center">
                Create Survey
              </a>
            )}
            {user?.role === "responder" && (
              <a href="/wallet" className="block btn btn-secondary text-center">
                View Wallet
              </a>
            )}
          </div>
        </div>

        <div className="card">
          <h2 className="text-xl font-bold text-gray-100 mb-4">Getting Started</h2>
          <ul className="space-y-2 text-gray-400">
            <li>• Complete your profile to get better survey matches</li>
            <li>• Earn rewards by completing surveys as a responder</li>
            <li>• Create and distribute surveys as a question owner</li>
            <li>• Manage your wallet and track earnings</li>
          </ul>
        </div>
      </div>
    </div>
  );
}
